"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var lodash_1 = require("lodash");
var React = require("react");
var react_places_autocomplete_1 = require("react-places-autocomplete");
var AddressAutocompleteUtils_1 = require("./AddressAutocompleteUtils");
var DEFAULT_ERROR = 
/* tslint:disable:max-line-length */
"Sorry, we couldn't find that address. Try it without apt/suite/floor numbers.";
var AddressGoogleQuery = /** @class */ (function (_super) {
    __extends(AddressGoogleQuery, _super);
    function AddressGoogleQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            errorText: '',
            loadedGoogleMaps: false
        };
        _this.defaultProps = {
            maxSuggestions: 5
        };
        _this.handleChange = function (value) {
            if (_this.state.errorText !== '') {
                _this.setState({ errorText: '' });
            }
            _this.props.onChange(value);
        };
        _this.handleSelect = function (addressInput, placeId) {
            if (placeId) {
                AddressAutocompleteUtils_1.parseGoogleMapsResponse(placeId).then(_this.props.onSelect);
            }
        };
        _this.handleError = function () {
            _this.setState({ errorText: DEFAULT_ERROR });
        };
        return _this;
    }
    AddressGoogleQuery.prototype.componentDidMount = function () {
        var _this = this;
        this.loadedGoogleMapsInterval = setInterval(function () { return _this.checkLoadedGoogleMaps(); }, 100);
        this.checkLoadedGoogleMaps();
    };
    AddressGoogleQuery.prototype.componentWillUnmount = function () {
        clearInterval(this.loadedGoogleMapsInterval);
    };
    AddressGoogleQuery.prototype.checkLoadedGoogleMaps = function () {
        var loadedGoogleMaps = !!lodash_1.get(window, 'google.maps.places');
        if (loadedGoogleMaps) {
            this.setState({ loadedGoogleMaps: loadedGoogleMaps });
            clearInterval(this.loadedGoogleMapsInterval);
        }
    };
    AddressGoogleQuery.prototype.render = function () {
        var _a = this.props, value = _a.value, children = _a.children, maxSuggestions = _a.maxSuggestions;
        var _b = this.state, errorText = _b.errorText, loadedGoogleMaps = _b.loadedGoogleMaps;
        // Handle cases when Google maps API is slow or is not loading at all.
        if (!loadedGoogleMaps) {
            var defaultInputProps = {
                disabled: true,
                value: '',
                onBlur: function () { return undefined; },
                onChange: function () { return undefined; },
                onKeyDown: function () { return undefined; }
            };
            return children(defaultInputProps, [], '');
        }
        return (React.createElement(react_places_autocomplete_1["default"], { value: value, onChange: this.handleChange, onSelect: this.handleSelect, onError: this.handleError, searchOptions: { types: ['address'] } }, function (res) {
            var inputProps = res.getInputProps({});
            var suggestions = res.suggestions
                .map(function (suggestion) { return (__assign({}, suggestion, { props: res.getSuggestionItemProps(suggestion) })); })
                .slice(0, maxSuggestions);
            return children(inputProps, suggestions, errorText);
        }));
    };
    return AddressGoogleQuery;
}(React.Component));
exports["default"] = AddressGoogleQuery;
